import { Season } from './season.enum';
import { Resource } from 'angular4-hal';

export class Departure extends Resource {
    day: number;
    time: string;
    seasson: string;
}
